import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from '../../../shared/pagination/pagination';
import { AuditLog } from '../../../core/models/audit-log';
import { AuditApiService } from '../../../core/api-services/audit-api.service';
import { ChangeSummaryItem } from '../../../core/interfaces/change-summary-item';

@Component({
  selector: 'app-admin-audit-log',
  imports: [CommonModule, FormsModule, PaginationComponent],
  templateUrl: './audit-log.html',
  styleUrl: './audit-log.scss',
})
export class AdminAuditLogComponent implements OnInit {
  private readonly auditApi = inject(AuditApiService);

  searchQuery = '';
  filterAction = '';
  currentPage = 1;
  readonly pageSize = 8;

  readonly actionOptions = [
    'ADDED',
    'MODIFIED',
    'DELETED',
    'UNCHANGED'
  ];

  logs: AuditLog[] = [];
  showRevertConfirm = false;
  logToRevert: AuditLog = null!;
  revertMessage = '';

  ngOnInit(): void {
    this.refresh();
  }

  get filteredLogs(): AuditLog[] {
    let results = [...this.logs];

    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      results = results.filter((log) => {
        const entityName = String(log.entityName ?? '').toLowerCase();
        const action = String(log.action ?? '').toLowerCase();
        return entityName.includes(query) || action.includes(query);
      });
    }

    if (this.filterAction) {
      results = results.filter((log) => String(log.action) === this.filterAction);
    }

    return results;
  }

  get paginatedLogs(): AuditLog[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.filteredLogs.slice(startIndex, startIndex + this.pageSize);
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filteredLogs.length / this.pageSize));
  }

  get showingFrom(): number {
    if (this.filteredLogs.length === 0) {
      return 0;
    }
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get showingTo(): number {
    return Math.min(this.currentPage * this.pageSize, this.filteredLogs.length);
  }

  refresh(): void {
    this.auditApi.getAuditLogs().subscribe((data: AuditLog[]) => {
      this.logs = data;
    });
  }

  onFiltersChanged(): void {
    this.currentPage = 1;
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
  }

  getChangeSummary(changes: Record<string, unknown> | string | null | undefined): ChangeSummaryItem[] {
    const parsedChanges = this.parseChanges(changes);

    return Object.entries(parsedChanges).map(([field, change]) => {
      const values = change as Record<string, unknown>;
      return {
        field: this.formatFieldName(field),
        oldValue: this.formatChangeValue(values['Old'] ?? values['old']),
        newValue: this.formatChangeValue(values['New'] ?? values['new']),
      };
    });
  }

  private parseChanges(changes: Record<string, unknown> | string | null | undefined): Record<string, unknown> {
    if (!changes) return {};

    if (typeof changes !== 'string') return changes;

    try {
      const parsed = JSON.parse(changes);
      return parsed && typeof parsed === 'object' ? parsed as Record<string, unknown> : {};
    } catch {
      return {};
    }
  }

  private formatFieldName(field: string): string {
    return field.replace(/Id\b/g, 'ID');
  }

  private formatChangeValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  }

  getActionClass(a: string): string {
    const action = String(a).toUpperCase();

    if (action.includes('ADDED') || action.includes('UNCHANGED')) return 'badge-success';
    if (action.includes('MODIFIED') || action.includes('SAVED')) return 'badge-primary';
    if (action.includes('DELETED')) return 'badge-danger';
    if (action.includes('ASSIGNED')) return 'badge-warning';
    return 'badge-neutral';
  }

  // hasSnapshot(log: AuditLog): boolean {
  //   //return log.snapshot != null;
  //   return false;
  // }

  // requestRevert(log: AuditLog): void {
  //   this.logToRevert = log;
  //   this.showRevertConfirm = true;
  // }

  // cancelRevert(): void {
  //   //this.logToRevert = null;
  //   this.showRevertConfirm = false;
  // }

  // confirmRevert(): void {
  //   // if (!this.logToRevert?.snapshot) 
  //   //   return;
  //   // const snapshot = this.logToRevert.snapshot as any;

  //   // this.templateApi.getAllApplicationTemplates().subscribe((templates) => {
  //   //   const idx = templates.findIndex((t: any) => t.id === snapshot.id);
  //   //   const existingTemplate = idx > -1 ? templates[idx] : null;
  //   //   const revertTimestamp = new Date().toISOString();
  //   //   const revertedTemplate = {
  //   //     //...snapshot,
  //   //     //createdAt: existingTemplate?.createdDate ?? snapshot.createdAt,
  //   //     updatedAt: revertTimestamp,
  //   //   } as any;

  //   //   if (idx > -1) {
  //   //     templates[idx] = revertedTemplate;
  //   //   } else {
  //   //     templates.unshift(revertedTemplate);
  //   //   }

  //   //   this.templateApi.saveTemplates(templates);
  //   //   // this.templateApi.appendAuditLog({
  //   //   //   action: 'TEMPLATE_REVERTED',
  //   //   //   //createdDate: revertTimestamp,
  //   //   //   //targetCountry: revertedTemplate.targetCountry,
  //   //   //   //templateName: revertedTemplate.templateName,
  //   //   //   //fieldCount: revertedTemplate.applicationFields.length,
  //   //   // });
  //   //   this.revertMessage = `"${revertedTemplate.templateName}" has been reverted to its previous version.`;
  //   //   this.cancelRevert();
  //   //   this.refresh();
  //   //});

  //   setTimeout(() => { this.revertMessage = ''; }, 5000);
  // }
}
